<template>
  <div>
    <div class="app-main-inner-row" style="padding-top: 10px;">
      <div class="filters">
        <el-form
          :inline="true"
          label-width="50px"
          label-position="left"
          @submit.native.prevent="filter.pageNum=1;toQuery()"
        >
          <el-form-item :label="$t('common.btn.query')">
            <el-input
              v-model="filter.likeName"
              no="queryInput"
              :placeholder="$t('common.tips.fuzzyCodeSearch')"
              style="width:310px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="triggers">
        <el-button no="query" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
        <el-button no="new" type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
        <el-button no="edit" type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
        <el-button no="delete" size="mini" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
      </div>
    </div>
    <div class="app-main-inner-row row-grid" style="flex-grow: 1;">
      <cargo-ag-grid
        no="grid"
        config-module="101374"
        :grid-params.sync="girdParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
      />
    </div>
    <div class="app-main-inner-row row-pagination">
      <cargo-pagination
        v-show="total>0"
        no="pagination"
        config-module="101374"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="400px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="100px" label-position="left">
          <el-form-item required>
            <span slot="label">{{ $t('CargoMsg.Cargo_Code') }}</span>
            <el-input v-model="editDialog.form.code" no="code" />
          </el-form-item>
          <el-form-item required>
            <span slot="label">{{ $t('CargoMsg.Cargo_ChineseName') }}</span>
            <el-input v-model="editDialog.form.name" no="name" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="cancel">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getChargeGroupList, saveChargeGroup, delChargeGroup } from '@/api/basicData/chargeGroup'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import { queryChargeItemNoUse } from '@/api/payservice'
import { getFilterCacheList } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'

export default {
  name: 'NewChargeGroup',
  components: { cargoAdvanceSelect },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [], // 去掉每列的菜单
          filter: true
        },
        onRowClicked: event => {
          this.onRowClicked(event)
        },
        onRowSelected: this.updateChargeItemList
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Code'),
          field: 'code',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ChineseName'),
          field: 'name',
          width: 200
        }
      ],
      rowData: null,
      editDialog: {
        visible: false,
        title: '',
        form: {
          uuid: '',
          code: '',
          name: ''
        }
      },
      chargeItemList: [],
      chargeItemUuidList: []
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    }
  },
  methods: {
    onShow() {
      if (this.rowData === null) {
        this.rowData = []
        this.updateChargeItemList()
        this.toQuery()
      }
    },
    toQuery() {
      const loading = getLoading()
      this.updateChargeItemList()
      this.filter.likeName = this.filter.likeName.trim()
      getChargeGroupList(this.filter).then(res => {
        if (this.gridApi) {
          this.gridApi.setRowData(res.data.list)
        } else {
          this.rowData = res.data.list
        }
        this.filter.pageNum = res.data.pageNum
        this.filter.pageSize = res.data.pageSize
        this.total = Number(res.data.total)
      }).finally(() => loading.close())
    },
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.form = {
          uuid: '',
          code: '',
          name: ''
        }
        this.editDialog.title = this.$t('CargoMsg.Cargo_NewTo') + this.$t('Information.ChargeGroup')
      } else {
        const rows = this.gridApi.getSelectedRows()
        if (rows.length === 0) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        if (rows.length !== 1) {
          this.$message.warning(this.$t('common.tips.hasOneOnly'))
          return
        }
        this.editDialog.form = { ...rows[0] }
        if (this.editDialog.form.chargeItemUuids) {
          const thisList = getFilterCacheList(basicCacheKeys.basic_data_ChargeItem, (item) => {
            return this.editDialog.form.chargeItemUuids.includes(item.uuid)
          })
          if (!this.chargeItemList.includes(thisList[0])) {
            for (const item of thisList) {
              this.chargeItemList.splice(0, 0, item)
            }
          }
        }
        this.editDialog.title = this.$t('CargoMsg.Cargo_EditTo') + this.$t('Information.ChargeGroup')
      }
      this.editDialog.visible = true
    },
    save() {
      const form = this.editDialog.form
      if (!form.code) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CodeCanTBeEmpty'))
        return
      }
      if (!form.name) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ChineseNameCanTBeEmpty'))
        return
      }
      this.loading = getLoading()
      saveChargeGroup(form).then(() => {
        if (!form.uuid) {
          this.filter.pageNum = 1
        }
        this.editDialog.visible = false
        this.$message.success(this.$t('common.tips.saveSuccess'))
        this.toQuery()
      }).catch(() => {
        // this.editDialog.visible = false
      }).finally(() => {
        this.loading.close()
      })
    },
    remove() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$confirm(this.$t('common.tips.confirmDelete'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        this.syncRemove(rows, 0)
      }).catch(
        () => { }
      )
    },
    syncRemove(rows, index) {
      if (index < rows.length) {
        delChargeGroup(rows[index].uuid).then(() => {
          this.syncRemove(rows, index + 1)
        }).catch(() => {
          if (index > 0) {
            this.filter.pageNum = 1
            this.toQuery()
          }
        })
      } else {
        this.filter.pageNum = 1
        this.$message.success(this.$t('common.tips.deleteSuccess'))
        this.toQuery()
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    showName(chargeItemUuids) {
      let showName = ''
      for (const i of chargeItemUuids) {
        const userName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'uuid', i, 'zhName')
        if (userName) {
          if (showName.length > 0) {
            showName += ','
          }
          showName += userName
        }
      }
      return showName
    },
    // 更新费用项目下拉数据源
    async updateChargeItemList() {
      await queryChargeItemNoUse().then(res => {
        this.chargeItemUuidList = res.data
        this.chargeItemList = getFilterCacheList(basicCacheKeys.basic_data_ChargeItem, (item) => {
          return res.data.includes(item.uuid)
        })
      })
    },
    cancel() {
      this.editDialog.visible = false
    }
  }
}
</script>

<style>
</style>
